// extracted by mini-css-extract-plugin
export default {"wrapper":"ApplicationFilter_wrapper__wr1Hs"};